"use client";

import React, { useState, useEffect } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const Counter = ({
  end,
  duration = 2000,
  isVisible
}: {
  end: number;
  duration?: number;
  isVisible: boolean;
}) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let startTimestamp: number | null = null;
    const step = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      setCount(Math.floor(progress * end));
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }, [end, duration, isVisible]);
  return <span>{count.toLocaleString()}</span>;
};
export default function ImpactInNumbers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const stats = [{
    value: 500,
    label: "Partner Universities",
    suffix: "+"
  }, {
    value: 2,
    label: "Scholarships Secured",
    suffix: "M+"
  }, {
    value: 15000,
    label: "Successful Students",
    suffix: "+"
  }];
  return <section data-section-id="46892" id="our-global-impact" ref={ref} className="relative w-full py-24 overflow-hidden bg-primary dark">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-10">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623446/img/world_map_vector.png" alt="World Map Background" className="w-full h-full object-cover object-center" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 text-center">
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center space-y-4">
              <div className={cn("text-6xl md:text-7xl font-default font-bold text-white leading-tight transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")} style={{
            filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.3))"
          }}>
                <Counter end={stat.value} isVisible={isVisible} />
                {stat.suffix}
              </div>
              <div className={cn("text-sm md:text-base font-sans font-semibold uppercase tracking-widest text-secondary transition-all duration-700 delay-150", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")}>
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}